<template>
  <Popover
    v-model:open="isPopoverOpen"
    :modal="true"
  >
    <PopoverTrigger as-child data-testid="popover-trigger">
      <button class="!text-sm text-link cursor-pointer" type="button">{{ standard.standard_short_ref }}</button>
    </PopoverTrigger>
    <PopoverContent data-testid="popover-content"
      side="bottom"
      align="center"
      class="relative z-50 bg-white text-black border border-gray-400 rounded-md shadow-lg w-80 pointer-events-auto"
    >
      <PopoverArrow class="fill-gray-200 stroke-gray-400" :width="20" :height="12" />
      <div v-if="standard">
        <CopyTrackWrapper type="standard">
          <div class="flex justify-between bg-gray-200 p-2 rounded-t-md">
            <span class="text-md font-medium pl-3">{{ standard.standard_short_ref }}</span>
            <GbButton
              size="xs"
              rounded
              :iconOnly="true"
              aria-label="close standard popover"
              gbTheme="grayTertiary"
              @click="handleClose"
              @keydown.space="handleClose"
              @keydown.esc="handleClose"
            >
              <span class="material-icons-outlined text-xl">close</span>
            </GbButton>
          </div>

          <p class="pt-2 px-5 text-md" v-html="standard.standard_text" />
          <div class="pt-2 pb-4 px-5">
            <CopyButton :stringToCopy="standard.standard_short_ref + ' ' + standard.standard_text" :buttonTheme="'grayOutlineSecondary'" size="xs" iconClass="material-icons-outlined" buttonText="Copy" tooltipText="Standard copied" :autoHideTooltip="true"/>
          </div>
        </CopyTrackWrapper>
      </div>
    </PopoverContent>
  </Popover>
</template>

<script setup lang="ts" name="StandardPopover">
import { PopoverArrow } from 'reka-ui'
import Popover from '@/components/popover/Popover.vue'
import PopoverContent from '@/components/popover/PopoverContent.vue'
import PopoverTrigger from '@/components/popover/PopoverTrigger.vue'
import { Standard } from '@/standards/standard_types'
import CopyButton from '@/components/CopyButton.vue'
import CopyTrackWrapper from '@/components/CopyTrackWrapper.vue'
import { PropType, ref, watch, provide } from 'vue'
import GbButton from '@/components/GbButton.vue'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin'
import { EVENT_NAMES } from '@/tracking/analytics/event_names'

const isPopoverOpen = ref(false)

// Remove edited_text_type from parent context while preserving other context
const analytics = getAnalyticsTracker().removeContext('edited_text_type')

const props = defineProps({
  standard: {
    type: Object as PropType<Standard>,
    required: true,
  },
})

const handleClose = () => {
  isPopoverOpen.value = false
}

watch(isPopoverOpen, (newValue) => {
  if (newValue) {
    analytics.sendEvent(EVENT_NAMES.PRESENTLEVELS.SUMMARY.CLICKED_STANDARD_LINK, {
      plw_standard_code: props.standard.standard_short_ref,
      plw_standard_set: props.standard.standard_set_code
    })
  }
})
</script>
